// @ts-nocheck
import React from 'react'

const Divider = () => {

  return (
    <>
      <div className="mb-6">
        <hr className="my-8 border-0 border-t border-slate-200" />
      </div>
    </>

  );
};

export default Divider



